/* eslint-disable jsx-a11y/anchor-has-content */
import * as Tooltip from '@radix-ui/react-tooltip';
import { IfBrowser } from '@tbitop/ssr';
import { IconContext } from 'phosphor-react';
import type { PropsWithChildren } from 'react';
import { Notifications } from '../notification';

export const DesignSystem = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Tooltip.Provider>
      <IconContext.Provider value={{
        size: 24,
        weight: 'bold',
        color: 'currentColor',
        mirrored: false,
      }}>
        <IfBrowser>
          <Notifications />
        </IfBrowser>
        {children}
      </IconContext.Provider>
    </Tooltip.Provider>
  );
};
